'use strict';

define(['utils/extendable', 'utils/helpers'], function (Extendable, utils) {

    var Tooltip = Extendable.extend({
        'constructor': function constructor(name) {
            this.el = document.createElement('div');
            this.el.className = 'jw-icon jw-icon-tooltip ' + name + ' jw-button-color jw-reset jw-hidden';
            this.container = document.createElement('div');
            this.container.className = 'jw-overlay jw-reset';
            this.openClass = 'jw-open';
            this.componentType = 'tooltip';
            // 如果是高清选择，则需要加上一个label zhangzhe 2017-03-23
            if (name === 'jw-icon-hd') {
                var hdLabel = document.createElement('span');
                hdLabel.className = 'jw-hd-label';
                this.el.appendChild(hdLabel);
            } else if (name === 'jw-icon-playrate') {
                var playrateLabel = document.createElement('span');
                playrateLabel.className = 'jw-playrate-label';
                this.el.appendChild(playrateLabel);
            } else if (name === 'jw-icon-cc') {
                var ccLabel = document.createElement('span');
                ccLabel.className = 'jw-cc-label';
                this.el.appendChild(ccLabel);
            }
            this.el.appendChild(this.container);
        },

        addContent: function addContent(elem) {
            if (this.content) {
                this.removeContent();
            }

            this.content = elem;
            this.container.appendChild(elem);
        },
        removeContent: function removeContent() {
            if (this.content) {
                this.container.removeChild(this.content);
                this.content = null;
            }
        },
        hasContent: function hasContent() {
            return !!this.content;
        },
        element: function element() {
            return this.el;
        },
        openTooltip: function openTooltip(evt) {
            this.trigger('open-' + this.componentType, evt, { 'isOpen': true });
            this.isOpen = true;
            utils.toggleClass(this.el, this.openClass, this.isOpen);
        },
        closeTooltip: function closeTooltip(evt) {
            this.trigger('close-' + this.componentType, evt, { 'isOpen': false });
            this.isOpen = false;
            utils.toggleClass(this.el, this.openClass, this.isOpen);
        },
        toggleOpenState: function toggleOpenState(evt) {
            if (this.isOpen) {
                this.closeTooltip(evt);
            } else {
                this.openTooltip(evt);
            }
        }
    });

    return Tooltip;
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/view/components/tooltip.js
 ** module id = 190
 ** module chunks = 0
 **/